import React from 'react'
import { useTranslation } from 'react-i18next'
import AccordionContent from '../../../../../components/Accordion/AccordionContent'
import CompensationAccordion from '../../../../../components/Accordion'
import { usePayoutPopupContext } from '../context'
import { useCompensationPopupStyles } from '../styles'
import PayoutLabel from '../components/PayoutLabel'
import useAccordionLabel from '../components/AccordionLabel'
import AnnualTeamBonusRelatedAmount from './AnnualTeamBonusRelatedAmount'
import clsx from 'clsx'

const AnnualPayoutContent = () => {
  const { labelAsAccordion, smallSpacingLabel, aqua100Label, leftAlignedToAccordionLg } = useCompensationPopupStyles()
  const { t } = useTranslation()
  const { data, updatePopoverPosition } = usePayoutPopupContext()

  const renderAnnualTeamBonusPayoutLabel = useAccordionLabel({
    value: data?.annualPayout?.teamBonus?.annualTeamBonusPayout ?? 0,
    label: 'annual_team_bonus_payout',
    classNames: () => ({ container: clsx(smallSpacingLabel, aqua100Label) }),
  })

  if (!data) {
    return null
  }

  return (
    <>
      <CompensationAccordion onToggleHandler={updatePopoverPosition} renderLabel={renderAnnualTeamBonusPayoutLabel}>
        <AccordionContent>
          <AnnualTeamBonusRelatedAmount />
        </AccordionContent>
      </CompensationAccordion>

      <PayoutLabel
        classes={{ label: clsx(labelAsAccordion, leftAlignedToAccordionLg), value: labelAsAccordion }}
        label={t('compensation_popup_annual_team_bonus_rate_label')}
        value={data.annualPayout?.teamBonus?.teamBonusRate ?? 0}
        format="percentage"
      />
    </>
  )
}

export default AnnualPayoutContent
